<div id="layoutError">
    <div id="layoutError_content">
        <main><ng-content></ng-content></main>
    </div>
    <div id="layoutError_footer"><sb-footer></sb-footer></div>
</div>
